module.exports = __webpack_public_path__ + "img/tag2.372e2739.png";